function getHeight() {
    return window.innerHeight || (document.documentElement || document.body).clientHeight;
}

function getScrollTop() {
    return window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
}

export default {
    getHeight,
    getScrollTop,
}
